// Ubicación de cada parada. Si la parada tiene boletería o agencia cargada (panel Agencias), se usa esa dirección exacta;
// si no, el centro aproximado de la localidad.
const APPROX = {
  "Virrey del Pino": [-34.8406, -58.6406], "González Catán": [-34.7700, -58.6280], Laferrere: [-34.7487, -58.5853], "Isidro Casanova": [-34.7065, -58.5730],
  "Rotonda Crovara": [-34.6936, -58.5394], "Crovara y General Paz": [-34.6878, -58.4905], "Villa Celina": [-34.7053, -58.4810], "San Justo": [-34.6847, -58.5609],
  "Puente La Noria": [-34.7072, -58.4539], Liniers: [-34.6429, -58.5262], "Terminal Dellepiane": [-34.6555, -58.4656],
  Retiro: [-34.5889, -58.3725], "El Turista": [-34.4677, -58.6745], Pacheco: [-34.4731, -58.6556], Escobar: [-34.3475, -58.7937],
  Campana: [-34.1899, -58.9472], Rosario: [-32.9383, -60.6614], "Santa Fe": [-31.6438, -60.7028], "San Cristóbal": [-30.3105, -61.2372],
  "Campo Garay": [-29.7, -61.47], "Logroño": [-29.5, -61.6833], Tostado: [-29.2322, -61.7692], Bandera: [-28.8889, -62.2667],
  "Añatuya": [-28.4606, -62.8347], "Matará": [-28.1167, -63.1833], "Suncho Corral": [-27.9333, -63.4333], Taboada: [-27.97, -63.75],
  "Fernández": [-27.9167, -63.8876], Forres: [-27.8833, -63.9667], "Beltrán": [-27.8292, -64.0611], "La Banda": [-27.7355, -64.2494],
  "Santiago del Estero": [-27.7785, -64.2634], "Termas de Río Hondo": [-27.4851, -64.8757], "Tucumán": [-26.8351, -65.1941],
  "Brea Pozo": [-28.2433, -63.9533], Loreto: [-28.3019, -64.1906], "San Pedro de Guasayán": [-27.9667, -65.1667], Lavalle: [-28.1975, -65.115],
  "Frías": [-28.6372, -65.1281], Clodomira: [-27.5744, -64.1311], "La Aurora": [-27.35, -64.35], "Pozo Hondo": [-27.1636, -64.4898],
  "Nueva Esperanza": [-26.2, -64.2407], "Quimilí": [-27.6458, -62.4156], Weisburd: [-27.32, -62.58], Tintina: [-27.0294, -62.7078],
  "Campo Gallo": [-26.5847, -62.8458], "Monte Quemado": [-25.8036, -62.8281],
};
// Paradas ubicadas con su dirección (Relevamiento_agencias.xlsx + OpenStreetMap)
const EXACT = {
  "González Catán": [-34.76346, -58.61874, "Catán Shopping, Ruta 3"],
  "San Justo": [-34.68531, -58.56104, "Rotonda de San Justo"],
  "Terminal Dellepiane": [-34.65159, -58.46389, "Terminal Dellepiane, Av. Perito Moreno 3950"],
  Pacheco: [-34.47282, -58.65595, "Terminal El Talar, Av. Hipólito Yrigoyen 2338 (Ruta 197)"],
};
// Localidad de la agencia (antes de la coma) que no coincide con el nombre de la parada
const ALIAS = { "San Miguel de Tucumán": "Tucumán", CABA: "Retiro", "El Talar": "Pacheco" };

const agencyCity = (a) => { const c = (a.city || "").split(",")[0].trim(); return ALIAS[c] || c; };

export const placeFor = (city, agencies) => {
  const a = (Array.isArray(agencies) ? agencies : []).find((x) => x.type !== "puntoenvio" && x.lat != null && agencyCity(x) === city);
  if (a) return { lat: a.lat, lng: a.lng, label: a.name, address: a.address, exact: true };
  const e = EXACT[city];
  if (e) return { lat: e[0], lng: e[1], label: city, address: e[2], exact: true };
  const p = APPROX[city];
  return p ? { lat: p[0], lng: p[1], label: city, address: "Ubicación aproximada de la localidad", exact: false } : null;
};

export const distanceKm = (p, a) => {
  const r = (d) => (d * Math.PI) / 180;
  const h = Math.sin(r(a.lat - p.lat) / 2) ** 2 + Math.cos(r(p.lat)) * Math.cos(r(a.lat)) * Math.sin(r(a.lng - p.lng) / 2) ** 2;
  return 12742 * Math.asin(Math.sqrt(h));
};
export const fmtKm = (k) => (k < 1 ? `${Math.round(k * 1000)} m` : `${k < 10 ? k.toFixed(1) : Math.round(k)} km`);

export const directionsUrl = (p) => `https://www.google.com/maps/dir/?api=1&destination=${p.lat},${p.lng}`;
